import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=4aae3e76&scoped=true&"
import script from "./TemplateModal.vue?vue&type=script&lang=js&"
export * from "./TemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aae3e76",
  null
  
)

export default component.exports